/* eslint-disable no-unused-vars */
import Swiper, { Navigation } from 'swiper';

export default function initSliderBlocks(el) {
    const elContainer = document.querySelectorAll(el);
    const elObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0) {
                    new Swiper(entry.target, {
                        loop: false,
                        navigation: {
                            nextEl: '.w-slider-arrow-right',
                            prevEl: '.w-slider-arrow-left',
                        },
                        breakpoints: {
                            // when window width is >= 320px
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 0,
                            },
                            // when window width is >= 640px
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                        },
                        modules: [Navigation],
                    });
                }
            });
        },
        {
            threshold: 0.2,
        }
    );
    elContainer.forEach((target) => {
        elObserver.observe(target);
    });
}
